<app-menu-selector
  *ngIf="regions"
  [data]="regions"
  [label]="'region' | translate"
  [placeholderLabel]="'chooseRegionUpload' | translate"
  [inputId]="'region-selector'"
  (selectionChanged)="onRegionChanged($event)"
></app-menu-selector>
